<template>
  <v-container>
    <ConfirmationDialog2 ref="confirmationDialog" />
    <PageHeader no-padding subtitle="Manage the Continuous Stations linked from Aquarius." />
    <v-card class="mb-2">
      <v-alert key="alert" outline class="my-0" type="error" :value="!aquariusSynchronizer">
        <div class="primary--text">
          The Aquarius Synchronizer is offline.
        </div>
      </v-alert>
      <v-card-text>
        The stations below were found in Aquarius during a <strong>Sync</strong> and linked to EnviroData continuous
        stations. <br />
        <br />

        <h4>Linked Stations</h4>
        Stations are initially linked by their <strong>Site Identifier</strong>. Once linked, even if the Site
        Identifier is changed
        in Aquarius, the link is preserved and the Site Identifier in the table below will be updated. <br />
        When a station is deleted in Aquarius, the linked station below is set to inactive. When a station in
        Aquarius is found with the same Site Identifier as an inactive station, the station will become active. <br />
        <br />

        <!-- <h4>Archive Stations</h4>
        To archive a linked station, <strong>archive</strong> the station from EnviroData. All tenant
        time series settings for that station will be locked. The time series data would be queried from the Envirodata archive database! <br />
        <br /> -->

        <h4>Deleting Stations</h4>
        To permanently delete a linked station, <strong>delete</strong> the station from EnviroData. All tenant
        time series settings for that station will be lost!
      </v-card-text>
    </v-card>

    <Subheader v-model="search" title="Aquarius Stations" search="aquarius stations">
      <SyncAquariusStationsDialog />
    </Subheader>
    <v-card>
      <v-divider />
      <v-data-table :pagination.sync="pagination" :headers="headers" :items="stations" :search="search">
        <template v-slot:items="{ item }">
          <td>{{ item.AquariusId }}</td>
          <td>{{ item.StationId }}</td>
          <td>{{ item.Description }}</td>
          <td>
            <v-icon v-if="item.IsDeleted" color="error">clear</v-icon>
            <v-icon v-else color="success">done</v-icon>
          </td>
          <!-- <td>
            <v-icon v-if="item.IsArchived" color="success">done</v-icon>
            <v-icon v-else color="error">clear</v-icon>
          </td> -->
          <td>
            <!-- <v-btn :disabled="item.IsArchived" :loading="item.deleting" @click="archiveStation(item)" small color="warning">
              <v-icon>archive</v-icon>
              Archive
            </v-btn>
            | -->
            <v-btn :disabled="item.IsArchived" :loading="item.deleting" @click="hardDelete(item)" small color="error">
              <v-icon>delete_forever</v-icon>
              Delete
            </v-btn>
            
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import SyncAquariusStationsDialog from './SyncAquariusStationsDialog'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const adminAquariusStations = createNamespacedHelpers('adminaquariusstation')
  const app = createNamespacedHelpers('app')

  export default {
    components: {
      SyncAquariusStationsDialog,
    },
    data: () => ({
      search: '',
      headers: [{
        text: 'AquariusId',
        align: 'left',
        value: 'AquariusId',
      },
      {
        text: 'Site Identifier',
        align: 'left',
        value: 'StationId',
      },
      {
        text: 'Description/Location Name',
        align: 'left',
        value: 'Description',
      },
      {
        text: 'Is Active',
        align: 'left',
        value: 'IsDeleted',
      },
      // {
      //   text: 'Is Archived',
      //   align: 'left',
      //   value: 'IsArchived',
      // },
      {
        text: 'Actions',
        align: 'left',
        value: 'actions',
      },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    }),
    computed: {
      ...adminAquariusStations.mapGetters(['stations', 'aquariusSynchronizer']),
    },
    methods: {
      ...adminAquariusStations.mapActions(['fetchStations', 'softDeleteStation', 'hardDeleteStation',
        'fetchService', 'archiveStationToTsDb',
      ]),
      ...app.mapActions(['setSnackbar']),
      async hardDelete(station) {
        let params = {
          title: `Delete station ${station.StationId}?`,
          text: `The station ${station.StationId} will be permanently deleted from EnviroData. <br/> All tenant settings related to the station are lost. Are you sure?`,
          confirmText: 'Delete',
          cancelText: 'Cancel',
          color: 'error',
          icon: 'delete_forever',
        }

        let confirmed = await this.$refs.confirmationDialog.confirm(params)
        if (!confirmed) return

        this.$set(station, 'deleting', true)

        try {
          await this.hardDeleteStation(station)

          this.setSnackbar({
            text: `Station ${station.StationId} deleted.`,
            color: 'info',
            icon: 'info',
          })

        } catch (error) {
          this.setSnackbar({
            text: error.Message,
            color: 'error',
            icon: 'error',
          })
        }

        this.$set(station, 'deleting', null)
      },
      async archiveStation(station) {
        let params = {
          title: `Archive station ${station.StationId}?`,
          text: `The station ${station.StationId} will be archived from Aquarius. <br/> Are you sure?`,
          confirmText: 'Archive',
          cancelText: 'Cancel',
          color: 'warning',
          icon: 'archive',
        }

        let confirmed = await this.$refs.confirmationDialog.confirm(params)
        if (!confirmed) return

        this.$set(station, 'deleting', true)

        try {
          await this.archiveStationToTsDb({
            service: this.aquariusSynchronizer,
            station: station,
          })

          this.setSnackbar({
            text: `Station ${station.StationId} archived.`,
            color: 'info',
            icon: 'info',
          })

        } catch (error) {
          this.setSnackbar({
            text: error.Message,
            color: 'error',
            icon: 'error',
          })
        }

        this.$set(station, 'deleting', null)
      },
      async initialize() {
        await this.fetchService()
      },
    },
    created() {
      this.initialize()
    },
    async mounted() {
      await this.fetchStations()
    },
  }
</script>